import { put, call } from 'redux-saga/effects';
import { questionnaireEvaluationFailureAction, questionnaireEvaluationSaveRequestSuccessAction } from '../actions';
import { QuestionnaireEvaluationService } from '../services';
export function* questionnaireEvaluationSaveQuestionnaireSaga(action, 
/*istanbul ignore next*/
questionnaireEvaluationQuestionsService = new QuestionnaireEvaluationService()) {
    const { requestData } = action.payload;
    try {
        yield call({
            context: questionnaireEvaluationQuestionsService,
            fn: questionnaireEvaluationQuestionsService.questionnaireEvaluationSaveQuestionnaire
        }, requestData);
        yield put(questionnaireEvaluationSaveRequestSuccessAction());
    }
    catch (error) {
        yield put(questionnaireEvaluationFailureAction(error.toString()));
    }
}
//# sourceMappingURL=questionnaireEvaluationSaveQuestionnaireSaga.js.map